import { onMounted, onUnmounted, onBeforeMount, ref, nextTick } from "vue";
import throttle from "lodash/throttle";
export default function useSizes(usedInVue = true) {
    const windowWidth = ref(0);
    const windowHeight = ref(0);
    const resizeCallback = ref(null);
    function resize() {
        windowWidth.value = window.innerWidth;
        windowHeight.value = window.innerHeight;
        if (resizeCallback.value !== null)
            resizeCallback.value();
    }
    const throttledResize = throttle(resize, 100);
    if (usedInVue) {
        onBeforeMount(() => {
            resize();
        });
        onMounted(async () => {
            window.addEventListener("resize", throttledResize, { passive: true });
            await nextTick();
            resize();
        });
        onUnmounted(() => {
            window.removeEventListener("resize", throttledResize);
        });
    }
    const nativeInit = () => {
        window.addEventListener("resize", throttledResize, { passive: true });
        resize();
    };
    return {
        windowWidth, windowHeight,
        resizeCallback,
        nativeInit,
    };
}
